RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const LOADING_VIEW_MESSAGE_TIME = 10000;
    const PERMASPINNY_RELOAD_MESSAGE_TIME = 50000;

    const LoadingView = views.BlockLoading = Marionette.Dashboard.views.BlockLoading.extend({
        ui: {
            message: '.x-message',
            permaspinnyMessage: '.x-permaspinny-message'
        },
        events: {
            'click .x-reload': 'reloadPage'
        },
        reloadPage: function () {
            window.location.reload();
        },
        clearMessage: function () {
            const me = this;
            me.ui.message.removeClass('in');
            me.$el.removeClass('message-in');
            clearTimeout(me.timeout);
        },
        showMessage: function () {
            const me = this;
            me.ui.message.addClass('in');
            me.$el.addClass('message-in');
        },
        showPermaspinnyMessage: function () {
            const me = this;
            me.clearMessage();
            me.ui.permaspinnyMessage.removeClass('hide');
        },
        onShow: function () {
            const me = this;
            me.clearMessage();
        },
        showForView: function () {
            const me = this;
            me.clearMessage();
            Marionette.Dashboard.views.BlockLoading.prototype.showForView.apply(me, arguments);

            if (me._showingError && me._isRendered) {
                // re-render as showError likely changed $el
                me.render();
                me._showingError = false;
            }

            // const curationId = arguments[0]?.dashboardModel?.getCuration?.()?.id;
            // NOTE set a timer for a little ways out, to reassure the user we are still working on it; and then
            // another timer further out, to catch perma-spinny situations; see #34788
            me.timeout = setTimeout(function () {
                if (me.isDestroyed) {
                    return;
                }

                me.showMessage();

                me.timeout = setTimeout(function () {
                    if (me.isDestroyed) {
                        return;
                    }

                    me.showPermaspinnyMessage();

                    // NOTE commenting this out for now, as there are too many cases where the loading view is not being
                    // cleaned up correctly, so this event fires but no permaspinny is happening. see #34788
                    // RivalIQ.execute('loadingViewTimeout', {
                    //     curationId: curationId
                    // });

                }, PERMASPINNY_RELOAD_MESSAGE_TIME);

            }, LOADING_VIEW_MESSAGE_TIME);
        },

        showError: function (errorClass, errorTemplate, errorTemplateArgs) {
            const me = this;

            me.$el.css('height', 'auto');
            me.$el.addClass(errorClass);
            me.$el.html(Marionette.TemplateCache.get(errorTemplate)(errorTemplateArgs));
            me._showingError = true;
        },

        hideForView: function () {
            const me = this;
            Marionette.Dashboard.views.BlockLoading.prototype.hideForView.apply(me, arguments);
            me.clearMessage();
        }
    });

    function showErrorView(error) {
        const me = this;

        if (error) {
            if (me.loadingView) {
                me.loadingView.showError('widget-error', '#widgetErrorView');
            }

            // it's possible that the loadingview is being used without a dashboardModel, don't assume one exists.
            if (_.result(me.dashboardModel, 'isExporting')) {
                RivalIQ.export.failExport(_.get(error, ['responseJSON', 'error', 'message'], error));
            }
        }
    }

    RivalIQ.views.CollectionView = Marionette.Dashboard.views.CollectionView.extend({
        LoadingView: LoadingView,
        onLoadDataError: showErrorView
    });
    RivalIQ.views.ItemView = Marionette.Dashboard.views.ItemView.extend({
        LoadingView: LoadingView,
        onLoadDataError: showErrorView
    });
    RivalIQ.views.LayoutView = Marionette.Dashboard.views.LayoutView.extend({
        LoadingView: LoadingView,
        onLoadDataError: showErrorView
    });
    RivalIQ.views.CompositeView = Marionette.Dashboard.views.CompositeView.extend({
        LoadingView: LoadingView,
        onLoadDataError: showErrorView
    });

    RivalIQ.views.LoadingTableView = RivalIQ.views.TableContainer.mixin({
        LoadingView: LoadingView,
        baseRender: RivalIQ.views.TableContainer.prototype.render,
        mixins: {
            loading: Marionette.Dashboard.mixins.Loading,
            asyncRenderWatch: Marionette.Dashboard.mixins.AsyncRenderWatch
        },

        onLoadDataError: showErrorView,

        onRender: function () {

        },

        onRenderLoaded: function () {

            const me = this;
            RivalIQ.views.TableContainer.prototype.onRender.apply(me, arguments);
        }
    });
});
